import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { push } from "redux-first-history";

import payments from "../../redux/actions/payments";
import { getBalance, getNotifications } from "../../redux/actions/session";

import Menu from "../../components/menuDesktop/MenuDesktop";
import MobileMenu from "../../components/menuMobile/MenuMobile";
import CurrencyInput from "../currencyInput/CurrencyInput";

import imgSucesso from "../../assets/images/img-sucesso.png";

import "../../pages/cpfRegistration/CpfRegistration.scss";

const formatCpfDisplay = (value) => {
  if (!value) return "";
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length !== 11) return value;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
};

const WithdrawClient = () => {
  const token = useSelector((state) => state.session.token);
  const cpf = useSelector((state) => state.session.cpf);
  const email = useSelector((state) => state.session.email);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [amount, setAmount] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    dispatch(getBalance());
    dispatch(getNotifications());
  });

  useEffect(() => {
    if (!email) return;
    if (token && !cpf) {
      dispatch(push("/cpf?redirect=withdraw"));
    }
  }, [token, cpf, email, dispatch]);

  if (!token) return null;

  const handleClose = () => navigate("/");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formattedAmount = amount
      .trim()
      .replace("R$", "")
      .replace(",", ".");

    setIsSubmitting(true);
    const status = await dispatch(payments.createWithdraw(formattedAmount));
    setIsSubmitting(false);
    if (status === 200) setSuccess(true);
  };

  const isInvalidAmount =
    !amount ||
    parseFloat(amount.replace(/R\$/g, "").replace(",", ".")) <= 0;

  return (
    <>
      <Menu />

      <div
        className="tx-modal-overlay"
        role="dialog"
        aria-modal="true"
        onClick={(e) => {
          if (e.target === e.currentTarget) handleClose();
        }}
      >
        {!success ? (
          <form className="tx-modal" onSubmit={handleSubmit} noValidate>
            <header className="tx-modal__header">
              <h2 className="tx-modal__title">Sacar</h2>
              <button
                type="button"
                className="tx-modal__close"
                onClick={handleClose}
                aria-label="Fechar"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </header>

            <p className="tx-modal__description">
              Saques são realizados via PIX para o CPF cadastrado na conta.
            </p>

            {cpf && (
              <div className="tx-field">
                <span className="tx-field__label">Chave Pix</span>
                <input
                  type="text"
                  className="tx-field__input tx-field__input--readonly"
                  value={formatCpfDisplay(cpf)}
                  readOnly
                />
              </div>
            )}

            <label className="tx-field">
              <span className="tx-field__label">Quanto quer sacar?</span>
              <CurrencyInput
                amount={amount}
                setAmount={setAmount}
                className="tx-field__input"
              />
            </label>

            <button
              type="submit"
              className="tx-modal__submit"
              disabled={isSubmitting || isInvalidAmount}
            >
              {isSubmitting ? "Enviando..." : "Sacar"}
            </button>
          </form>
        ) : (
          <div className="tx-modal">
            <header className="tx-modal__header">
              <h2 className="tx-modal__title">Saque solicitado com sucesso!</h2>
              <button
                type="button"
                className="tx-modal__close"
                onClick={handleClose}
                aria-label="Fechar"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </header>

            <div className="tx-modal__success-icon">
              <img src={imgSucesso} alt="" />
            </div>

            <p className="tx-modal__description">
              Seu saque foi requisitado. Dentro de instantes o valor será
              enviado para a chave PIX (CPF): {cpf}
            </p>

            <p className="tx-modal__hint">
              Caso tenha algum problema, fale com a gente pelo whatsapp.
            </p>

            <button
              type="button"
              className="tx-modal__submit"
              onClick={handleClose}
            >
              Fechar
            </button>
          </div>
        )}
      </div>

      <MobileMenu />
    </>
  );
};

export default WithdrawClient;
